import { Box, Divider, Typography } from '@fullstory/components';
import { allSpecObjectsBySlug, namedElementsSelectors } from '@fullstory/redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { PillText } from '@fullstory/library-ui';
import { NamedElementBody } from '../NamedElementBody';

const { getNamedElementsById } = namedElementsSelectors;

export type SpecElementBodyProps = {
  slug: string;
};

export const SpecElementBody: React.VFC<SpecElementBodyProps> = ({ slug }) => {
  const namedElementsById = useSelector(getNamedElementsById);
  const specElement = useSelector(allSpecObjectsBySlug)[slug];

  const elementId = specElement?.mapping?.elementId;
  if (!elementId) {
    return <></>;
  }

  const namedElementRecord = namedElementsById.get(elementId);
  if (!namedElementRecord) {
    return <></>;
  }

  return (
    <div data-component="SpecElementBody">
      {specElement?.config?.notes && (
        <Box paddingBottom={8}>
          <Box paddingBottom={8}>
            <Typography variant="body3" color="neutrals-n7">
              {specElement.config.notes}
            </Typography>
          </Box>
          <Divider />
        </Box>
      )}
      <Box marginBottom={8}>
        <Typography variant="body3">
          <FormattedMessage defaultMessage="Mapped To Element" id="TTEfvp" />
        </Typography>
      </Box>
      <Box marginBottom={24}>
        <PillText>{namedElementRecord.namedElement?.name}</PillText>
      </Box>
      <NamedElementBody namedElementRecord={namedElementRecord} omitDescription />
    </div>
  );
};
